import React, { useEffect, useState } from 'react';
import logo from '../../../assets/images/logoDark.svg';
import Field from '../Field';
import Form from '../../molecules/Form/Form';
import { useForm } from '../../molecules/Form';
import { StyledSignUp } from './Otp/Otp.styles';
import authService from '../../../services/authService';
import Button from '../../molecules/Button';
import Toast from '../../molecules/Toast';
import OnboardingTemplate from '../OnboardingTemplate';
import { FormContent } from '../Login/Login.styles';
import { useNavigate } from 'react-router-dom';
const ChangePassword = () => {
  const [form] = useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    form.setFieldsValue({
      email: localStorage.getItem('otp_email'),
    });
  }, []);

  async function handelResetPassword(e) {
    const payload = {
      email: localStorage.getItem('otp_email'),
      newPassword: e.confirm_password,
    };
    setLoading(true);
    try {
      const resp = await authService.ChangePassword(payload);
      if (resp.message) {
        Toast({
          type: 'success',
          message: resp.message,
        });
        navigate('/successful');
        setLoading(false);
      }
    } catch (error) {
      Toast({
        type: 'error',
        message: error.message,
      });
      setLoading(false);
    }
  }
  return (
    <StyledSignUp>
      <OnboardingTemplate>
        <FormContent>
          <div className="heading-text">
            <h1>Reset password!</h1>
            <p>
              Please enter your new password to
              <br /> secure your account.
            </p>
          </div>
          <div className="login-body">
            <Form form={form} className="input-wrap" onSubmit={handelResetPassword}>
              <Form.Item
                rounded label="New Password"
                type="password"
                name="new_password"
                placeholder="Enter new password"
                $bgWhite
                rules={[
                  {
                    required: true,
                  },
                ]}>
                <Field />
              </Form.Item>
              <Form.Item
                rounded
                label="Confirm New Password"
                type="password"
                name="confirm_password"
                placeholder="Confirm new password"
                $bgWhite
                rules={[
                  {
                    required: true,
                    message: 'Confirm password is required',
                  },
                  {
                    transform: value => value !== form.getFieldValue('new_password'),
                    message: 'The two passwords that you entered do not match',
                  },
                ]}>
                <Field />
              </Form.Item>
              <Button width="100%" delayAnimation loader={loading} disabled={loading}>
                Reset my password
              </Button>
            </Form>
          </div>
        </FormContent>
      </OnboardingTemplate>
    </StyledSignUp>
  );
};

export default ChangePassword;
